import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getProducts } from "api/product.api";
import { gracefulList } from "lib/queryHelpers";
import { QUERY_KEYS } from "config/queryKeys";
import { DEFAULT_STALE_TIME } from "config/constants";

export const useGetProducts = () => {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: QUERY_KEYS.products.list(),
    queryFn: gracefulList(getProducts, { products: [] }),
    initialData: () => queryClient.getQueryData(QUERY_KEYS.products.list()),
    select: (data) => data?.products ?? [],
    staleTime: DEFAULT_STALE_TIME,
  });
};